import script from "./Pages.vue?vue&type=script&setup=true&lang=ts"
export * from "./Pages.vue?vue&type=script&setup=true&lang=ts"

import "./Pages.vue?vue&type=style&index=0&id=5e91b076&scoped=true&lang=scss"

import exportComponent from "/Users/mayo/htdocs/halp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e91b076"]])

export default __exports__